import { createGlobalStyle } from "styled-components";

const FontStyle = createGlobalStyle`
@import url('https://fonts.googleapis.com/css2?family=Architects+Daughter&display=swap');

body {
    font-family: 'Architects Daughter', cursive;
}
`

export default FontStyle;